// PT-BR labels for ThesaurusOriginDto, used to group/label a content's "complementaries"
// (ThesaurusResponse[]) in the search results list.
export const THESAURUS_ORIGIN_LABELS = {
  AttachmentType: "Tipo de Arquivo",
  DramaturgyOrigin: "Procedência",
  DramaturgyPlot: "Trama",
  DramaturgyThematic: "Temática",
  DramaturgyUniverse: "Universo",
  DramaturgySpace: "Espaço",
  DramaturgyNarrative: "Narrativa",
  DramaturgyPeriod: "Período",
  ProjectGenre: "Gênero",
  DramaturgyEpoch: "Época",
  ProjectSubGenre: "Subgênero",
  VarietyTag: "Tag",
  ContentAssociationType: "Associação",
  ProjectFormat: "Formato",
  ResearchArea: "Área",
  ProjectAdequationEvaluationHour: "Horário",
  LiteraryWorkFormat: "Formato",
  ProjectAdequationEvaluationPlataform: "Plataforma",
  ProjectChannel: "Canal",
  CharacterName: "Nome do Personagem",
  CharacterLastName: "Sobrenome do Personagem",
  CharacterNickName: "Apelido do Personagem",
  CharacterActivities: "Atividades do Personagem",
  LiteraryWorkUniverse: "Universo",
  LiteraryWorkGenre: "Gênero",
  Deadlines: "Prazo",
  Platform: "Plataforma",
  Reason: "Motivo",
  AssessmentType: "Tipo de Avaliação",
};

export const getThesaurusOriginLabel = (origin) => THESAURUS_ORIGIN_LABELS[origin] || origin;
